import axios from "@/repositories/client";

axios.getContracts = (query, pagination, args) => {

  args.hotel = args.hotel || null;
  args.dropdown = args.dropdown || false;

  let options = {
    params: {
      ...(args.hotel ? {hotels: [ args.hotel ]} : {}),
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/contracts`, options)
    .then(response => {
      if (!args.dropdown)
        return response.data;
      else
        return response.data.data.map(contract => ({text: contract.info.name, value: contract.id}));
    });
};

axios.getContract = (contract) => {
  return axios.get(`athena/v1/contracts/${contract}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveContract = (contract) => {
  const url = `athena/v1/contracts` + (contract.id ? `/${contract.id}` : '');
  const verb = contract.id ? 'PUT' : 'POST';

  contract.options.rooms = contract.options.rooms.filter(r => (!!r.room_type_id && !!r.price && !!r.release && !!r.inventory));
  contract.options.installments = contract.options.installments.filter(i => (!!i.due && !!i.value));

  return axios.request({method: verb, url: url, data: contract})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyContract = (contract) => {
  return axios.delete(`athena/v1/contracts/${contract}`)
    .then(response => {
      return response.data;
    });
};

export default axios;